import { useEffect, useState } from 'react'

import { MenuItem, Skeleton } from '@mui/material'

import { MULTI_SELECT_BOX_TEST_IDS } from '../MultiSelectBox.constants'

type ConsoleMultiSelectSkeletonProps = {
  loading?: boolean
}

export const ConsoleMultiSelectSkeleton = ({
  loading = false
}: ConsoleMultiSelectSkeletonProps) => {
  const [skeletonCount, setSkeletonCount] = useState(0)

  useEffect(() => {
    if (loading) {
      setSkeletonCount(Math.floor(Math.random() * 4) + 3)
    }
  }, [loading])

  if (!loading) return null

  return (
    <>
      {Array.from(Array(skeletonCount).keys()).map((index) => (
        <MenuItem
          key={`skeleton-${index}`}
          disabled
          data-testid={MULTI_SELECT_BOX_TEST_IDS.skeletonItem}
          sx={{
            opacity: '1 !important',
            color: 'text.primary',
            '&.Mui-disabled': {
              color: 'text.primary',
              opacity: 1
            }
          }}
        >
          <Skeleton
            variant="rectangular"
            width="100%"
            height={20}
            sx={{
              borderRadius: 0.5,
              bgColor: 'grey.300'
            }}
          />
        </MenuItem>
      ))}
    </>
  )
}
